import { useCallback, useRef, useState } from 'react'
import {
    hasAnyIntegrationActive,
    useIntegrationsAndApiData
} from './use-integrations-and-api-data'

export function useBillingConfirmation() {
    const { data } = useIntegrationsAndApiData()
    const wasEmpty = !hasAnyIntegrationActive(data)

    const [isOpen, setIsOpen] = useState(false)
    const pendingActionRef = useRef(null)

    const requestConfirmation = useCallback(
        action => {
            if (wasEmpty) {
                pendingActionRef.current = action
                setIsOpen(true)
            } else {
                action()
            }
        },
        [wasEmpty]
    )

    const confirm = useCallback(() => {
        const action = pendingActionRef.current
        pendingActionRef.current = null
        setIsOpen(false)
        if (action) action()
    }, [])

    const cancel = useCallback(() => {
        pendingActionRef.current = null
        setIsOpen(false)
    }, [])

    return { isOpen, requestConfirmation, confirm, cancel }
}
